<span #rippleRef class="ripple" [ngClass]="[color, animateClass]" (animationend)="animateRipple($event)"></span>
